/**
 * 👤 User Transform Utils
 * Feature-Sliced Design - Entities Layer
 * 
 * User 도메인 전용 변환 유틸리티 함수들
 * 이전 packages/shared/utils/data-transform-utils에서 FSD entities로 이주
 */ // AuthorInfo type for consistent author information across the application
// Placeholder URLs list (can be extended as needed)
var PLACEHOLDER_URLS = [
    'https://via.placeholder.com/150'
];
/**
 * Transforms an API UserSummary object to the AuthorInfo type used in the UI.
 * Sets profileImageUrl to undefined if the image is missing or is a placeholder URL.
 * 
 * @param author UserSummary object from API or null/undefined
 * @returns Transformed AuthorInfo object
 */ export var transformUserSummaryToAuthorInfo = function(author) {
    var basicInfo = author === null || author === void 0 ? void 0 : author.basicInfo;
    var imageUrl = basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.profileImageUrl;
    // Set to undefined if image is missing or is in placeholder URL list
    var finalProfileImageUrl = imageUrl && !PLACEHOLDER_URLS.includes(imageUrl) ? imageUrl : undefined;
    var result = {
        id: String((basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.id) || '0'),
        username: (basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.username) || '',
        displayName: (basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.displayName) || '',
        name: (basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.displayName) || '',
        profileImageUrl: finalProfileImageUrl,
        verified: false // Default to false since API response doesn't include verified info
    };
    return result;
};
